const clientCode = () => { return window.location.href.split('/')[4] }

export default clientCode
